import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const HideOnMobile = styled.div`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
    height: 100%;
  }
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  width: 100%;
  min-width: 0;
`;

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  width: 100%;
  min-width: 0;
`;

export const AddGuestRow = styled.div`
  display: flex;
  margin-bottom: ${space[4]};
`;
